import { parseRangeFromTs } from '@mi-front/core';
import { MrtTable } from '@mi-front/ui';
import { useDebounce } from 'use-debounce';
import { useFocus } from '../../../logger/screens/stream/stores/stream-screen.store';
import { PlayButton } from '../../components/audit-result/PlayButton';
import { useAuditMatchColumns } from '../../hooks/useAuditMatchColumns';
import { useAuditSpotMatches } from '../../hooks/useAuditSpotMatches';
import { Station } from '@app/core/types/stations';

interface Props {
  readonly station: Station;
}

export function WaveScheduleStatusView(p: Props) {
  const focus = useFocus();
  const [debouncedFocus] = useDebounce(focus, 300);
  const matchesQuery = useAuditSpotMatches(p.station, parseRangeFromTs(debouncedFocus));

  const columns = useAuditMatchColumns({
    timeColumnType: 'time',
    actionsColumn: (row) => <PlayButton match={row.original} />,
  });

  return (
    <MrtTable
      columns={columns}
      data={matchesQuery.data ?? []}
      state={{ isLoading: matchesQuery.isLoading }}
    />
  );
}
